import { AddCircleOutline } from "@material-ui/icons";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { ManageOfferingsBtn } from "features/ManageOfferings/modules/ManageOfferingsBtn/ManageOfferingsBtn";
import React, { useState } from "react";
import FaqEditor from "ui/pages/manageWebpage/FAQ/components/faqList/FaqEditor";

export const AddFaqBtn = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <ManageOfferingsBtn
        btnText="Add new question"
        startIcon={AddCircleOutline}
        action={() => setOpenModal(true)}
      />
      <ExlyModal
        title="Add FAQs"
        header="Add FAQs"
        primaryBtnText="Confirm"
        secondaryBtnText="Cancel"
        open={openModal}
        onClose={() => setOpenModal(false)}
        modal_props={{
          customFooter: <></>,
        }}
        mobile_modal_props={{
          customFooter: <></>,
        }}
        padded={false}
      >
        <FaqEditor isModal={true} setShowUpload={setOpenModal} />
      </ExlyModal>
    </>
  );
};
